import { render, staticRenderFns } from "./StageEvidenceImportDialog.vue?vue&type=template&id=55f84065&scoped=true"
import script from "./StageEvidenceImportDialog.vue?vue&type=script&lang=js"
export * from "./StageEvidenceImportDialog.vue?vue&type=script&lang=js"
import style0 from "./StageEvidenceImportDialog.vue?vue&type=style&index=0&id=55f84065&prod&lang=scss&scoped=true"
import style1 from "./StageEvidenceImportDialog.vue?vue&type=style&index=1&id=55f84065&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f84065",
  null
  
)

export default component.exports